import { Controller } from "@hotwired/stimulus"

// Disables (and optionally relabels) a form's submit control the instant the form is
// submitted, so a slow response or an impatient extra click/tap can't fire a second request
// before the page navigates away. Intended for plain (non-remote) form posts where neither
// Turbo Drive nor jquery-ujs is available to provide this out of the box.
//
// Usage: put data-controller="disable-submit" and data-action="submit->disable-submit#disable"
// on the <form>, and data-disable-submit-target="submit" on the submit button/input. An
// optional data-processing-text="..." on that same element swaps its label while disabled.
export default class extends Controller {
  static targets = ["submit"]

  disable() {
    if (!this.hasSubmitTarget || this.submitTarget.disabled) return

    const button = this.submitTarget
    button.disabled = true

    const processingText = button.dataset.processingText
    if (!processingText) return

    if (button.tagName === "INPUT") {
      button.value = processingText
    } else {
      button.textContent = processingText
    }
  }
}
